import { Observable } from 'rxjs';
import { NotificationsApi } from '../parsers';
import { combineEpics } from 'redux-observable';
import get from 'lodash/get';

import {
  NOTIFICATIONS_FETCH_REQUESTED,
  notificationsReset,
  notificationsSucceeded,
  notificationsFailed,
  notificationsRead,
  notificationsClearSucceeded,
  notificationsClearFailed,
} from '../redux/notifications';

import {
  NOTIFICATIONS_MODAL_OPENED,
  NOTIFICATIONS_MODAL_CLOSED,
} from '../redux/modals';

import { clearNotifications, fetchNotifications } from '../utils/api';

import { ACCOUNT_FETCH_SUCCEEDED, LOG_OUT_REQUESTED } from '../redux/account';

import type { ActionObs, Store, Obs } from '../types';

export function notificationsEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(NOTIFICATIONS_FETCH_REQUESTED, ACCOUNT_FETCH_SUCCEEDED)
    .switchMap(() =>
      fetchNotifications()
        .map(resp => NotificationsApi.parse(resp))
        .map(({ errors, newNotifications, notifications: list }) => {
          if (errors.length) {
            return notificationsFailed(errors.join(','));
          }

          const hasNewNotifications = newNotifications > 0;
          return notificationsSucceeded(hasNewNotifications, list);
        })
        .catch(err => Observable.of(notificationsFailed(err.message))),
    );
}

export function notificationsResetEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(LOG_OUT_REQUESTED)
    .switchMap(() => Observable.of(notificationsReset()));
}

export function notificationsOpenedEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(NOTIFICATIONS_MODAL_OPENED).switchMap(() => {
    const state = store.getState();
    const hasNewNotifications = get(state, 'notifications.containsNew');

    if (hasNewNotifications) {
      return clearNotifications().map(resp => {
        if (resp.status === 'success') {
          return notificationsClearSucceeded();
        } else {
          return notificationsClearFailed(
            'unable to clear rails notifications',
          );
        }
      });
    }
    return Observable.empty();
  });
}

export function notificationsClosedEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(NOTIFICATIONS_MODAL_CLOSED).switchMap(() => {
    return Observable.of(notificationsRead());
  });
}

export default combineEpics(
  notificationsEpic,
  notificationsResetEpic,
  notificationsOpenedEpic,
  notificationsClosedEpic,
);
